export const background = {
  "title": "Add Background",
  "editImageTitle": "Current Image",
  "titleUpdate": "Update Background",
  "addMessage": "This file already contains a Background. Would you like to update the existing Background with the one you are adding?</br>Note: If you choose to add another Background, it might overlap the existing one.",
  "removeMessage": "Do you want to delete the background from document?",
  "removeNoneMessage": "Foxit PDF Editor can't find any background in the document.",
  "emptyMessage": "The background is empty, do you want to cancel this operation? Click \"OK\" to exit the Background dialog box, or click \"Cancel\" to continue with the current operations.",
  "color": "From color: ",
  "showPreview": "Show Preview",
  "pageRangeOptions": "Page Range Options"
}
